import api from "./api";

// Camada de serviço do Módulo de Câmbio (cotação do dia: à vista + cheque 30/60/90).
// Mesmo contrato de envelope do módulo de produtos:
//   - index / latest             -> payload CRU em resp.data
//   - create/update/delete/show  -> envelope: resp.data.data.result

// Desembrulha o envelope padrão { success, data: { message, result } }.
function unwrap(resp) {
  return resp.data && resp.data.data ? resp.data.data.result : resp.data;
}

// Histórico de cotações da empresa, mais recente primeiro.
// params opcionais: { limit, from, to, base_currency, quote_currency }
const list = (domain, params = {}) =>
  api
    .get("exchange-rates", { params: { domain, ...params } })
    .then((resp) => resp.data);

// Cotação vigente (última com data <= hoje). Pode devolver null.
const latest = (domain, params = {}) =>
  api
    .get("exchange-rates/latest", { params: { domain, ...params } })
    .then((resp) => resp.data);

// Publicar o mesmo dia de novo ATUALIZA a linha (o backend faz upsert por
// empresa+data+par de moedas) — corrigir a taxa da manhã é caso normal de uso.
const publish = (payload) => api.post("exchange-rates", payload).then(unwrap);

const update = (id, payload) =>
  api.put(`exchange-rates/${id}`, payload).then(unwrap);

const remove = (id) => api.delete(`exchange-rates/${id}`).then(unwrap);

export default { list, latest, publish, update, remove };
